export const AllowedOrdersSortField = ['VERIFICATION', 'TIME'] as const;

export type OrdersSortField = (typeof AllowedOrdersSortField)[number];
